import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import VueDragDrop from 'vue-drag-drop';
import i18n from './locales/i18n';
import draggable from 'vuedraggable';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueDragscroll from 'vue-dragscroll';
import '@/components/Validator/index';

Vue.use(VueDragscroll)
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueDragDrop);
Vue.use(draggable);

//Vue.prototype.$http = axios;
//load the token from the localStorage
const token = localStorage.getItem("token");
// Is there is any token then we will simply append default axios authorization headers
if(token){
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
